import { Controller, Control, FieldErrors } from 'react-hook-form';
import { TextField, TextFieldProps } from '@mui/material';

type ControlledTextFieldProps = {
    name: string;
    control: Control<any>;
    label: string;
    errors: FieldErrors;
    defaultValue?: string;
    type?: string;
    helperText?: string;
    format?: string;
} & TextFieldProps;

export default function TextFieldCustom({
    name,
    control,
    errors,
    defaultValue = '',
    type = 'text',
    helperText,
    ...rest
}: ControlledTextFieldProps) {
    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            render={({ field }) => (
                <TextField
                    {...field}
                    {...rest}
                    type={type}
                    error={!!errors[name]}
                    helperText={helperText ? helperText : (errors[name]?.message as string) || ''}
                />
            )}
        />
    );
}
